import { render, staticRenderFns } from "./AdminRegister.vue?vue&type=template&id=2cf72e48&scoped=true"
import script from "./AdminRegister.vue?vue&type=script&lang=js"
export * from "./AdminRegister.vue?vue&type=script&lang=js"
import style0 from "./AdminRegister.vue?vue&type=style&index=0&id=2cf72e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf72e48",
  null
  
)

export default component.exports